import type { ProfileTrackingResponse } from "../../profiles-tracking/services";
import type { Profile } from "../../profiles-tracking/components/edit-profile-modal/types";

type FollowingProfileRow = {
  profileBusinessId: string | number;
  razaoSocial?: string;
  locatidade?: string;
  email?: string;
  rankedKeywords?: number;
};

const splitLocality = (locality?: string) => {
  if (!locality) return { city: "", state: "" };

  const [city = "", state = ""] = locality
    .split(",")
    .map((part) => part.trim());

  return { city, state };
};

const normalizeDetailsValue = (value?: string) =>
  value === "Sem nome" || value === "Não categorizado" ? "" : value || "";

export const buildProfileForModal = (
  profile: FollowingProfileRow,
  details?: ProfileTrackingResponse,
): Profile => {
  const locality = splitLocality(profile.locatidade);

  return {
    id: String(profile.profileBusinessId),
    name: normalizeDetailsValue(details?.name) || profile.razaoSocial || "",
    category: normalizeDetailsValue(details?.category),
    categoryId: details?.categoryId,
    status: details?.status || "active",
    stats: {
      views: details?.stats?.views || 0,
      clicks: details?.stats?.clicks || 0,
      ranking: profile.rankedKeywords ?? details?.stats?.ranking ?? 0,
    },
    shortName: details?.shortName || profile.razaoSocial || "",
    openingDate: details?.openingDate || "",
    phone: details?.phone || "",
    email: details?.email || profile.email || "",
    website: details?.website || "",
    address: details?.address || "",
    city: details?.city || locality.city,
    state: details?.state || locality.state,
    zipCode: details?.zipCode || "",
    country: details?.country || "Brasil",
    description: details?.description || "",
    hours: details?.hours || {},
    whatsapp: details?.whatsapp || "",
    socialMedia: details?.socialMedia || {},
    serviceAreas: details?.serviceAreas || [],
    latitude: details?.latitude,
    longitude: details?.longitude,
    specialHours: details?.specialHours || [],
    amenities: details?.amenities || [],
    accessibility: details?.accessibility || [],
    parking: details?.parking || [],
    payments: details?.payments || [],
    serviceOptions: details?.serviceOptions || [],
    secondaryCategories: details?.secondaryCategories || [],
    secondaryCategoryIds: details?.secondaryCategoryIds || [],
  };
};
